export const STATUSES = {
  new: 'new',
  canceled: 'canceled',
  completed: 'completed',
  scheduled: 'scheduled'
}

export const STATUSES_CLINIC = {
  confirmed: 'confirmed',
  unconfirmed: 'unconfirmed',
  archived: 'archived',
  active: 'active'
}
